import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileDownloadInfo } from '@catcore/types/common';
import { FileBlobResponse } from '@catcore/utils';
import { RestHttpService } from '@catmodules/core/services/rest-http.service';
import { UserdataConfig } from '@catmodules/models/userdata-generation/types';
import { Restangular } from 'ngx-restangular';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UserdataConfigService extends RestHttpService<UserdataConfig> {

  /**
   * WebAPI v2 base endpoint
   * @type {string}
   */
  BASE_V2_API_ENDPOINT = 'userdata-configs';

  /**
   * WebAPI v2 base url
   * @type {string}
   */
  BASE_URL_V2 = `/api/${this.BASE_V2_API_ENDPOINT}`;

  constructor(
    service: Restangular,
    private http: HttpClient) {
    super('userdata-configs', service);
  }

  /**
   * Returns a observable userdata configuration for a provided project ID
   *
   * @param {string} projectId
   * @returns {Observable<any>}
   */
  getProjectConfig(projectId: string): Observable<any> {
    const url = `/api/projects/${projectId}/userdata-configuration`;
    return this.http.get(url).map((res) => res);
  }

  /**
   * Initialize the request to download userdata sources
   *
   * @param {UserdataConfig} config
   * @returns {Observable<FileDownloadInfo>}
   */
  downloadSources(config: UserdataConfig): Observable<FileDownloadInfo> {
    const url = `${this.BASE_URL_V2}/${config.id}/download_sources`;
    return this.fileDownload(url);
  }

  /**
   * Create userdata Package
   *
   * @param {UserdataConfig} config
   * @returns {Observable<any>}
   */
  createPackage(config: UserdataConfig) {
    const url = `${this.BASE_URL_V2}/${config.id}/create_package`;
    return this.http.get(url);
  }

  /**
   * Preparing the request and handling the response for retrieve a file form the WebAPI and preparing it for a download in the browser
   * @param url
   * @param params
   * @returns {Observable<FileDownloadInfo>}
   */
  private fileDownload(url, params = {}): Observable<FileDownloadInfo> {
    return this.http
      .get(url, { responseType: 'blob', observe: 'response', params })
      .map((response: HttpResponse<Blob>) => {
        const fileResponse = new FileBlobResponse(response);
        console.log(fileResponse.filename);
        return { blob: fileResponse.body, filename: fileResponse.filename };
      });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/userdata-generation/services/userdata-config.service.ts